// Viewed conversations are remembered for the browser session only
const STORAGE_KEY = 'viewedConversations'

export function getViewedConversationIds(): Set<string> {
  try {
    const viewed = sessionStorage.getItem(STORAGE_KEY)
    return new Set(Object.keys(viewed ? JSON.parse(viewed) : {}))
  } catch {
    return new Set()
  }
}

export function markConversationAsViewed(id: string | number): void {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    const viewed: Record<string, string> = stored ? JSON.parse(stored) : {}
    viewed[String(id)] = new Date().toISOString()
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(viewed))
  } catch {
    // Storage can be unavailable (private mode, quota); dimming is best effort
  }
}
